import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    NumberField,
    usePermissions,
    useResourceContext,
    EditButton
} from 'react-admin';
import { processPermissions, isAdminUser } from "../../common/roleUtils";

export const ClassList = props => {
    const { permissions } = usePermissions();
    const resource = useResourceContext();
    
    const propsObj = processPermissions(permissions, resource);
    const allowBulkActions = isAdminUser();
    
    return (
        <React.Fragment>
            <List 
                title="Classes" 
                {...props} 
                {...propsObj}
                sort={{ field: 'numeric_equivalent', order: 'ASC' }}
            >
                <Datagrid 
                    rowClick={propsObj.hasEdit ? 'edit' : false} 
                    bulkActionButtons={allowBulkActions ? undefined : false}
                >
                    {propsObj.hasEdit && <EditButton />}
                    <TextField source="id" />
                    <TextField source="class_name" label="Class Name" />
                    <NumberField source="numeric_equivalent" label="Class Number" />
                </Datagrid>
            </List>
        </React.Fragment>
    )
}
